import Vue from 'vue'
import Vuex from 'vuex'
import store from '../../store/index.js'
import ngl from './modules/ngl.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ...store.state,
    task: ''
  },

  mutations: {
    ...store.mutations,

    setTask (state, val) {
      state.task = val
    }
  },

  actions: {
    ...store.actions
  },

  getters: {
    ...store.getters
  },

  modules: {
    ngl
  }
})
